// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

import { validateMexicanPhoneNumber } from './mexican-phone-number';
import { validateMexicanZipcode } from './mexican-zipcode';
import { validateMexicanState } from './mexican-state';
import { validateMexicanCity } from './mexican-city';
import { validateMexicanAddress } from './mexican-address';
import { validateMexicanStreetNumber } from './mexican-street-number';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'mexicanPhoneNumber':
      return onlyWhen('field_mexican_phone_number') && validateMexicanPhoneNumber(userInputValue);

    case 'mexicanZipcode':
      return onlyWhen('field_mexican_zipcode') && validateMexicanZipcode(userInputValue);

    case 'mexicanState':
      return onlyWhen('field_mexican_state') && validateMexicanState(userInputValue);

    case 'mexicanCity':
      return onlyWhen('field_mexican_city') && validateMexicanCity(userInputValue);

    case 'mexicanAddress':
      return onlyWhen('field_mexican_address') && validateMexicanAddress(userInputValue);

    case 'mexicanStreetNumber':
      return onlyWhen('field_mexican_street_number') && validateMexicanStreetNumber(userInputValue);

    default:
      return VALID;
  }
}
